<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-12 alinmov3"></div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5 mt-2">
      <section class="section-page d-md-block d-sm-none d-none">
        <div class="back-search">
          <div
            class="container-fluid step-back1  back-2"
            v-lazy:background-image="'/header-help.jpg'"
            src="~rhomtrip_assets/src/img/header-help.jpg"
          >
            <div class="backover-one" id="search"></div>
            <div class="container contenido steps step-1">
              <div class="row relative">
                <div
                  class="col-xl-12 col-lg-12 col-md-12 align-self-center titles"
                >
                  <h1 class="title-one">Help center</h1>
                  <h2 class="subtitle-one">
                    Hello, How can we help?
                  </h2>
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 align-self-center box-tab mb-3"
                >
                  <div class="row justify-content-center">
                    <div class="col-xl-7 col-lg-10">
                      <div class="content-search">
                        <div class="box-search">
                          <div class="row">
                            <div
                              class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-12 align-self-center search-product-home"
                              v-bind:class="{
                                'is-invalid': $v.search.$error
                              }"
                            >
                              <div class="box-content">
                                <div class="icon-content">
                                  <i class="flaticon-question"></i>
                                </div>
                                <div class="input-content">
                                  <div class="d-block">
                                    <el-select
                                      v-bind:class="{
                                        'is-invalid': $v.search.$error
                                      }"
                                      id="from"
                                      name="from"
                                      filterable
                                      remote
                                      reserve-keyword
                                      :remote-method="getDocuemetsOptions"
                                      @change="selectDocument"
                                      :loading="loading"
                                      placeholder="Ask a Question"
                                      v-model="$v.search.$model"
                                      no-data-text="No found"
                                      automatic-dropdown
                                      ref="search"
                                      popper-class="w-select"
                                    >
                                      <el-option
                                        v-for="(option,
                                        index) in documentsOptions"
                                        :value="option._id"
                                        :label="option.title"
                                        :key="`${index}`"
                                      >
                                        <template>
                                          <div class="items-search">
                                            <div class="item-search">
                                              <div class="content-p">
                                                <span class="title-p">
                                                  {{ option.title }}
                                                </span>
                                                <span
                                                  class="country-price"
                                                  v-if="
                                                    option.type === 'RELEASE'
                                                  "
                                                >
                                                  {{ getTypeName(option.type) }}
                                                </span>
                                                <span
                                                  class="country-price"
                                                  v-else
                                                >
                                                  {{ getTypeName(option.type) }}
                                                  |
                                                  {{
                                                    getModuleName(option.module)
                                                  }}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </template>
                                      </el-option>
                                      <el-option
                                        v-if="simpleSearch"
                                        :value="simpleSearch"
                                        :label="simpleSearch"
                                        :key="`${documentsOptions.length + 1}`"
                                      >
                                        <template>
                                          <div class="items-search">
                                            <div class="item-search">
                                              <div class="content-p">
                                                Search for
                                                <strong>{{
                                                  simpleSearch
                                                }}</strong>
                                              </div>
                                            </div>
                                          </div>
                                        </template>
                                      </el-option>
                                    </el-select>
                                    <label for="from">
                                      Guide, Support or Release
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 align-self-center pl-lg-0"
                            >
                              <div class="bottom-search">
                                <base-button
                                  type="primary"
                                  class="button-search"
                                  @click="searchByKeyword"
                                >
                                  <i class="flaticon-bold-magnifier"></i
                                  >Search</base-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-12 col-lg-12 col-md-12 text-center">
                  <div class="d-flex justify-content-center">
                    <router-link :to="gotToType('guide')" class="tag-filters ">
                      Guides
                    </router-link>
                    <router-link
                      :to="gotToType('support')"
                      class="tag-filters "
                    >
                      Support
                    </router-link>
                    <router-link :to="gotToType('release')" class="tag-filters">
                      Releases
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="row mt-2">
          <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 mt-2">
            <div class="card">
              <h2 class="max-title">Modules</h2>
              <div class="row justify-content-center">
                <div
                  class="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-12"
                  v-for="(item, index) in modules"
                >
                  <router-link class="lowercase" :to="gotToItem(item.value)">
                    <div class="box-one">
                      <i :class="item.icon"></i>
                      <h3 class="title">{{ item.name }}</h3>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mt-2">
            <div class="card">
              <h2 class="max-title text-left">Last Release</h2>

              <CardArticles
                size="md"
                :excerpt="true"
                :searchCriteria="{
                  filtering: {
                    app: 'PARTNERS',
                    status: 'PUBLISHED'
                  },
                  sorting: {
                    sort: 'LAST_RELEASE',
                    order: 'DESCENDING'
                  },
                  pagination: {
                    limit: 1,
                    page: 1
                  }
                }"
              />

              <div>
                <h2 class="max-title text-left mt-2">Latest guides</h2>

                <CardArticles
                  size="md"
                  :excerpt="true"
                  :searchCriteria="{
                    filtering: {
                      app: 'PARTNERS',
                      type: 'GUIDE',
                      status: 'PUBLISHED'
                    },
                    sorting: {
                      sort: 'MOST_RECENT',
                      order: 'ASCENDING'
                    },
                    pagination: {
                      limit: 3,
                      page: 1
                    }
                  }"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapMutations } from "vuex";
import apps from "../../Commons/Utility/Apps";
import { required } from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
import CardArticles from "./Components/CardArticles";
import endpoint from "../../Commons/Services";
import { goBack } from "../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "Help",
  data() {
    return {
      search: "",
      loading: false,
      documents: [],
      timeoutId: null,
      simpleSearch: "",
      modules: apps.modules,
      apps: apps.apps,
      metaTagParams: {
        titlePage: "Help | RhomTrip Suppliers"
      }
    };
  },
  async created() {
    var bread = [
      {
        text: "Help",
        active: true
      }
    ];
    this.setItemsBread(bread);
  },
  methods: {
    goToPreviousPage() {
      goBack(this);
    },
    async searchByKeyword() {
      if (this.simpleSearch) {
        this.$router.push({
          path: `/help/searchResults?text=${this.simpleSearch}`
        });
      } else {
        this.$v.search.$touch();
      }
    },
    async getDocuemetsOptions(search) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        try {
          if (search !== "" && search.length > 1) {
            this.loading = true;
            let {
              data
            } = await endpoint.documents.services.getDocuemetsOptions(
              "SUPPLIERS",
              search,
              this.sesion.token
            );
            this.loading = false;
            this.simpleSearch = search;
            if (data.status) {
              let documents = data.data || [];
              this.documents = documents;
            } else {
              this.documents = [];
            }
          } else {
            this.simpleSearch = search;
            this.documents = [];
          }
        } catch (error) {
          this.simpleSearch = search;
          this.documents = [];
        }
      }, 500);
    },
    async selectDocument(documentId) {
      let document = this.documentsOptions.find(
        document => document._id === documentId
      );
      if (document) {
        let modelSlug =
          document.type === "RELEASE" ? document.type : document.module;
        let articleSlug = document.slug;
        this.$router.push({
          path: this.getPathToArticle(modelSlug, articleSlug)
        });
      }
    },
    getPathToArticle(modelSlug, articleSlug) {
      return modelSlug === "RELEASE"
        ? `/help/release/${articleSlug}`
        : `/help/${this.getSlugModule(modelSlug)}/${articleSlug}`;
    },
    gotToItem(modelSlug) {
      return modelSlug === "RELEASE"
        ? `/help/release`
        : `/help/${this.getSlugModule(modelSlug)}`;
    },
    gotToType(modelSlug) {
      return `/help/` + modelSlug;
    },
    getSlugModule(module) {
      if (module === "ACCOUNT") {
        return "account";
      } else if (module === "DRIVER") {
        return "driver";
      } else if (module === "AREAS") {
        return "areas";
      } else if (module === "CUSTOMERS") {
        return "customers";
      } else if (module === "DESTINATIONS") {
        return "destinations";
      } else if (module === "GLOBAL") {
        return "global";
      } else if (module === "LOGS") {
        return "logs";
      } else if (module === "PROFILE") {
        return "profile";
      } else if (module === "RATES") {
        return "rates";
      } else if (module === "RESERVATIONS") {
        return "reservations";
      } else if (module === "USERS") {
        return "users";
      } else if (module === "VEHICLES") {
        return "vehicles";
      } else if (module === "SCHEDULE") {
        return "schedule";
      }
    },
    getTypeName(type) {
      if (type === "RELEASE") {
        return "Release";
      } else if (type === "GUIDE") {
        return "Guide";
      } else if (type === "SUPPORT") {
        return "Support";
      }
    },
    getModuleName(module) {
      let item = this.modules.find(i => i.value === module);
      if (item) {
        return item.name;
      } else {
        return "";
      }
    },
    ...mapMutations(["setSigOut", "setItemsBread", "setMetaTags"])
  },
  computed: {
    ...mapGetters(["sesion", "metaTags"]),
    documentsOptions: function() {
      return this.documents.map(document => {
        return {
          _id: document._id,
          title: document.title,
          type: document.type,
          module: document.module,
          image:
            document.images.length > 0
              ? document.images[0]
              : "https://upcdn.io/FW25b8h/raw/documents/covers/rhomtrip-img-doc.png",
          short_description: document.short_description,
          slug: document.slug
        };
      });
    }
  },
  validations: {
    search: {
      required
    }
  },
  components: {
    WSelect: WSelect,
    CardArticles: CardArticles
  },
  destroyed() {
    clearTimeout(this.timeoutId);
  },
  async beforeMount() {
    this.setMetaTags(this.metaTagParams);
  },
  metaInfo() {
    return this.metaTags;
  }
};
</script>
